import { api } from '@/lib/api';
import {
  ExternalApiKey,
  CreateApiKeyRequest,
  UpdateApiKeyRequest,
  ApiKeyListResponse,
  ApiKeyQuery,
} from '../types';

/**
 * API Keys Service
 * Gerencia chamadas HTTP para o endpoint /api-keys
 */
export const ApiKeysService = {
  /**
   * Lista todas as API keys do usuário
   */
  async getApiKeys(query?: ApiKeyQuery, signal?: AbortSignal): Promise<ApiKeyListResponse> {
    const response = await api.get('/api-keys', {
      params: query,
      signal,
    });
    return response.data.data;
  },

  /**
   * Busca uma API key por ID
   */
  async getApiKey(id: string, signal?: AbortSignal): Promise<ExternalApiKey> {
    const response = await api.get(`/api-keys/${id}`, { signal });
    return response.data.data;
  },

  /**
   * Cria uma nova API key
   * IMPORTANTE: A key completa só é retornada uma vez nesta chamada
   */
  async createApiKey(data: CreateApiKeyRequest, signal?: AbortSignal): Promise<ExternalApiKey> {
    const response = await api.post('/api-keys', data, { signal });
    return response.data.data;
  },

  /**
   * Atualiza uma API key existente
   */
  async updateApiKey(
    id: string,
    data: UpdateApiKeyRequest,
    signal?: AbortSignal
  ): Promise<ExternalApiKey> {
    const response = await api.patch(`/api-keys/${id}`, data, { signal });
    return response.data.data;
  },

  /**
   * Ativa uma API key
   */
  async activateApiKey(id: string, signal?: AbortSignal): Promise<ExternalApiKey> {
    const response = await api.post(`/api-keys/${id}/activate`, {}, { signal });
    return response.data.data;
  },

  /**
   * Desativa uma API key
   */
  async deactivateApiKey(id: string, signal?: AbortSignal): Promise<ExternalApiKey> {
    const response = await api.post(`/api-keys/${id}/deactivate`, {}, { signal });
    return response.data.data;
  },

  /**
   * Exclui uma API key
   */
  async deleteApiKey(id: string, signal?: AbortSignal): Promise<void> {
    await api.delete(`/api-keys/${id}`, { signal });
  },
};
